import { useAsyncExecutor } from "async-executor-hook";
import { useState } from "react";
import { getErrorValueResponse } from "../../common/error/Error";

import LoadingSpinner from "../../images/loading_gray.gif";
import { HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import Modal from "../Modal/Modal";
import {
  Button,
  ButtonContainer,
  Container,
  TextArea,
  TextContainer,
} from "./RejectionCommentStyles";

const REJECTION_MAX_LENGTH = 124;

const RejectionCommentNotification = (props) => {
  const {
    toggleModal,
    title,
    sidebarInfoData,
    setShowModalSuccessErrorNotification,
    setMessageModalSuccessErrorNotification,
    setTitleModalSuccessErrorNotification,
    toggleSuccessReject,
    setOperationSuccess,
  } = props;

  const [comment, updateComment] = useState("");
  const onCommentChange = (ev) => {
    updateComment(ev.target.value);
  };
  const onClose = () => {
    if (toggleModal != null) {
      toggleModal();
    }
  };
  const isDisabled = comment === "";

  const updateCommentNotification = useAsyncExecutor(
    (params: any) => {
      const url_endpoint =
        params.sidebarInfoData.sidebar_details.patch_info.endpoint;
      const notification_type = params.sidebarInfoData.notification_type;
      if (notification_type === "senasa") {
        const params_senasa = {
          senasa_status_option: "rejected",
          senasa_rejected_comment: params.comment,
        };
        return networkBackendRequest(
          url_endpoint,
          HTTP_METHODS.PATCH,
          null,
          params_senasa
        ).then((resp) => resp.json());
      }

      if (notification_type === "electronic_mandate") {
        const params_electronic_mandate = {
          electronic_mandate_status_option: "rejected",
          electronic_mandate_rejected_comment: params.comment,
        };
        return networkBackendRequest(
          url_endpoint,
          HTTP_METHODS.PATCH,
          null,
          params_electronic_mandate
        ).then((resp) => resp.json());
      }
      if (notification_type === "third_party_billing_authorization") {
        const params_third_party_billing = {
          third_party_billing_authorization_status_option: "rejected",
          third_party_auth_rejected_comment: params.comment,
        };
        return networkBackendRequest(
          url_endpoint,
          HTTP_METHODS.PATCH,
          null,
          params_third_party_billing
        ).then((resp) => resp.json());
      }
      const paramsSenasa = {
        senasa_status_option: "reviewing",
        senasa_comment: "sasa",
      };
      return networkBackendRequest(
        "/volantes/third-party-billing-authorization-agent/ssssss",
        HTTP_METHODS.PATCH,
        null,
        paramsSenasa
      ).then((resp) => resp.json());
    },

    {
      onSuccess: () => {
        setTitleModalSuccessErrorNotification("Documento rechazado");
        setMessageModalSuccessErrorNotification(
          "Se ha rechazado el documento."
        );
        setShowModalSuccessErrorNotification(true);
        setOperationSuccess(true);
        toggleSuccessReject();
      },
      onError: (error) => {
        const errorMessage = getErrorValueResponse(error);
        setTitleModalSuccessErrorNotification("Atención");
        setMessageModalSuccessErrorNotification(errorMessage);
        setShowModalSuccessErrorNotification(true);
        toggleModal();
      },
    }
  );

  return (
    <Modal
      onOutsideClick={() => {
        onClose();
      }}
    >
      <Container>
        <h1>{title}</h1>
        <TextContainer>
          <h3>Motivo de rechazo</h3>
          <TextArea
            type="text"
            placeholder={"Escribe el motivo de rechazo"}
            onChange={onCommentChange}
            value={comment}
            maxLength={REJECTION_MAX_LENGTH}
          />
        </TextContainer>
        <ButtonContainer>
          <Button
            disabled={isDisabled || updateCommentNotification.isLoading}
            onClick={() => {
              updateCommentNotification.execute({ sidebarInfoData, comment });
            }}
          >
            {updateCommentNotification.isLoading && (
              <img className="icon" src={LoadingSpinner} alt="spinner" />
            )}
            Guardar motivo de rechazo
          </Button>
        </ButtonContainer>
      </Container>
    </Modal>
  );
};

export default RejectionCommentNotification;
